<template>
    <el-footer app padless absolute>
        <transition name="el-fade-in-linear">
            <div class="footer-wrap" v-loading="loading">
                <div>
                    <span style="font-size:14px; cursor:pointer"  @click="$router.push('/statement')" >
                        免责声明：
                    </span>
                    <span>
                        本站所有内容来源于互联网。如果本站部分内容侵犯您的权益，请您告知，站长会立即处理。
                    </span>
                </div>
                <div>
                    <span style="font-size:14px;">
                        友情链接：
                    </span>
                    <span v-if="item.enable=='1'" v-for="item in tableData" :key="item.id">
                        <span style="margin-right: 10px">
                            <a :href="item.address" >{{ item.name}} </a></span>
                    </span>
                </div>
                <div>&copy; 2022 - {{ new Date().getFullYear() }} By DashenAE</div>
                <div>
                    <img src="../assets/备案图标.png" style="width: 15px;height: 15px">
                    <a href="http://beian.miit.gov.cn/">
                        互联网ICP备案：粤ICP备2022051732号
                    </a>
                </div>

            </div>
        </transition>

    </el-footer>
</template>

<script>
    export default {
        name: "Bottom",
        data(){
            return{
                loading: false,
                tableData: [],
                total: 0,
                pageNum: 1,
                pageSize: 10,
            }
        },
        created() {
            this.load()
        },
        methods: {
            load() {
                this.request.get("/friendslink/page", {
                    params: {
                        pageNum: this.pageNum,
                        pageSize: this.pageSize,
                        name: this.name,
                    }
                }).then(res => {
                    this.tableData = res.data.records;
                    this.total = res.data.total
                })
            },
        }
    }
</script>

<style scoped>
    .footer-wrap {
        bottom: 0!important;
        width: 95rem;
        line-height: 2;
        position: relative;
        padding: 10px 20px;
        color: #fff;
        font-size: 10px;
        text-align: center;
        background: linear-gradient(-45deg, #ee7752, #ce3e75, #23a6d5, #23d5ab);
        background-size: 400% 400%;
        animation: Gradient 10s ease infinite;
    }
    .footer-wrap a {
        color: #eee !important;
    }
    @keyframes Gradient {
        0% {
            background-position: 0 50%;
        }
        50% {
            background-position: 100% 50%;
        }
        100% {
            background-position: 0 50%;
        }
    }


</style>
